import Model from './BaseModel';
import ClassificationBetType from './ClassificationBetType';

export default class Classification extends Model {
	resourceName() {
		return 'classifications';
	}

	fields() {
		return [
			'name',
			'selection_liability_limit',
			'multi_selections_liability_limit',
			'sgm_selection_liability_limit',
			'sgm_multi_selections_liability_limit'
		];
	}

	relationships() {
		return {
			bet_types: new ClassificationBetType()
		};
	}

	updateLimit() {
		return this.makePersistRequest({
			url: `${this.resourceUrl()}${this.id}`,
			method: 'POST',
			data: {
				selection_liability_limit: this.selection_liability_limit,
				multi_selections_liability_limit: this.multi_selections_liability_limit,
				sgm_selection_liability_limit: this.sgm_selection_liability_limit,
				sgm_multi_selections_liability_limit: this.sgm_multi_selections_liability_limit
			}
		});
	}
}
